import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Super() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/8F1118FD-086A-4431-BDC3-9E3742304384_plus.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
        <p>HINDI    SCIENCE</p>
        <h4>Super Practice Course on Mathematics for NDA 1 2022</h4> 
        <p>Lesson 13 • Mar 2, 2022 8:00 AM</p> 
        <p>Arpit Chaudhry</p>  
        </div>
    </div>        
  )
}
export default Super;